const bannedWords = [
  "maxis",
  "skrable",
  "maxi",
  "maximilian",
  "max",
  "skrableguy",
  "maxwell",
];

export default bannedWords;
